"use strict";
"use es6";
/* tslint:disable:no-empty */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;

function noop() {}